import { SocialMedia } from './enums';

export type SocialMediaLinkProps = {
  socialLink: string;
  socialName: SocialMedia;
};
